import Box from "@/common/components/Box";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import GoBackButton from "@/common/components/GoBackButton";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import Table from "@/common/components/Table";
import { showCardDefaultColumns } from "@/features/cards/constants/showCardDefaultColumns.constant";
import useCard from "@/features/cards/hooks/useCard";
import { useCardMarkAsApproved } from "@/features/cards/hooks/useCardMarkAsApproved";
import { PendingCardsTransformer } from "@/features/cards/services/pendingCardsTransformer";
import { ReviewButtons } from "@/features/establishmentLeadsFunnel/components/ReviewButtons";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

const PendingCardsShow = () => {
  const { id } = useParams();

  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const {
    data: card,
    isFetching: cardIsFetching,
    error: cardError = {} as any,
    refetch: refetchCard,
  } = useCard({ id });

  const {
    mutate: cardMarkAsValidated,
    isPending: cardMarkAsValidatedIsPending,
    isError: cardMarkAsValidatedIsError,
  } = useCardMarkAsApproved({
    cardId: id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientCard', id] });
      setMessages(['Cartão aprovado com sucesso!']);
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setMessages(error.response?.data.errors.base);
      }
    },
  });

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <GoBackButton
            fallback='/pending-cards'
            searchLastRouteFromFallback
          />

          <h2 className="text-2xl font-bold">Cartão para análise</h2>
        </div>

        {card?.status === 'awaiting_approval' && (
          <div>
            <ReviewButtons
              isPending={cardMarkAsValidatedIsPending}
              onApprove={() => cardMarkAsValidated()}
              hideDeclineButton
            />
          </div>
        )}
      </div>

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={cardError?.status}
        refetchFunction={refetchCard}
      >
        <Box className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            <h3 className="text-xl font-bold">Dados do cartão</h3>

            <div>
              <Table
                className="max-h-[calc(100vw-248px)]"
                rows={card ? PendingCardsTransformer.tableTransformer()([card]) : []}
                columns={showCardDefaultColumns({
                  showActions: card?.status === 'printed' || card?.status === 'validated',
                })}
                rowEmptyValue="--"
                page={1}
                totalPages={1}
                isLoadingData={cardIsFetching}
                loadingRows={1}
              />
            </div>
          </div>
        </Box>
      </ErrorMessageWrapper>

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={cardMarkAsValidatedIsError}
        />
      )}
    </div>
  );
};

export default PendingCardsShow;
